import { render, staticRenderFns } from "./RichmenuSettings.vue?vue&type=template&id=6e3fd56d&"
import script from "./RichmenuSettings.vue?vue&type=script&lang=js&"
export * from "./RichmenuSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports